import React, { useState ,useEffect} from "react";
// import "./AIML.css";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "antd";
import aimlImg from "../../../../utils/AiMl-removebg-preview.webp";
import { ArrowRightOutlined } from "@ant-design/icons";
import "./WebDevlopment.css"
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  FaRobot,
  FaCheckCircle,
  FaEye,
  FaSyncAlt,
  FaBrain,
  FaCog,
  FaChartLine,
  FaDatabase,
} from "react-icons/fa";

const AIMLDevelopment = () => {
  const navigate = useNavigate();
  const flipCards = [
    {
      title: "Machine Learning",
      description:
        "Building predictive models and algorithms that learn from data to make intelligent decisions.",
      icon: <FaBrain />,
    },
    {
      title: "Deep Learning",
      description: "Implementing neural networks for complex pattern recognition and analysis.",
      icon: <FaChartLine />,
    },
    {
      title: "Computer Vision",
      description:
        "Developing systems that can identify and process images and videos like human vision.",
      icon: <FaEye />,
    },
    {
      title: "Natural Language Processing",
      description:
        "Creating systems that understand, interpret and generate human language.",
      icon: <FaRobot />,
    },
    {
      title: "Predictive Analytics",
      description: "Using historical data to forecast future trends and behaviors.",
      icon: <FaChartLine />,
    },
    {
      title: "AI Chatbots",
      description:
        "Building intelligent conversational agents for customer service and support.",
      icon: <FaRobot />,
    },
    {
      title: "AI Consulting",
      description:
        "Strategic guidance to implement AI solutions that drive business value.",
      icon: <FaCog />,
    },
  ];
  const accountabilityItems = [
    {
      number: "1",
      title: "Expertise",
      description:
        "With a team of 30+ AI/ML experts, we're equipped to handle complex machine learning challenges. Our team includes PhDs and researchers specializing in cutting-edge AI technologies.",
    },
    {
      number: "2",
      title: "Experience",
      description:
        "With over 5 years in AI development, 50+ ML models deployed, and 35+ satisfied clients, we have a proven track record of delivering impactful AI solutions.",
    },
    {
      number: "3",
      title: "Data Mastery",
      description:
        "We possess deep expertise in data engineering, feature engineering, and model training to ensure your AI systems work with optimal accuracy and efficiency.",
    },
    {
      number: "4",
      title: "Business-First Approach",
      description:
        "We align AI solutions with your business objectives, ensuring measurable ROI and tangible business impact from our implementations.",
    },
    {
      number: "5",
      title: "Client Success",
      description:
        "Our AI solutions have helped clients achieve 30-300% improvements in key metrics like efficiency, accuracy, and customer satisfaction.",
    },
    {
      number: "6",
      title: "Continuous Learning",
      description:
        "We stay at the forefront of AI research, constantly updating our knowledge with the latest papers, frameworks, and techniques.",
    },
  ];
  useEffect(() => {
    // Set page title and meta description
    document.title = "AI & Machine Learning Development Services | Custom AI Solutions";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional AI and machine learning development services. Custom AI solutions, predictive analytics, computer vision, NLP, and intelligent automation systems.');
    }

    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  return (
    <>
      {/* Main AI/ML Development Section */}
      <section className="web-dev-section">
        <div className="web-dev-container">
          <div className="web-dev-text-content">
            <h1>
              Transforming Businesses with Intelligent AI & Machine Learning Solutions
            </h1>
            <p>
              Where Data Meets Intelligence. Power your business with cutting-edge AI algorithms
              and predictive models that drive real results.
            </p>
            <button
              className="web-dev-cta-button"
              onClick={() => navigate('/chaat')}
            >
              Let's discuss your AI project
            </button>
            <div className="web-dev-features">
              <div className="web-dev-feature-item">🧠 Deep Learning</div>
              <div className="web-dev-feature-item">📊 Predictive Analytics</div>
              <div className="web-dev-feature-item">👁️ Computer Vision</div>
              <div className="web-dev-feature-item">💬 NLP</div>
              <div className="web-dev-feature-item">🤖 AI Chatbots</div>
              <div className="web-dev-feature-item">🔍 Data Science</div>
            </div>
          </div>
          <div className="web-dev-image-content">
            <img src={aimlImg} alt="AI/ML Service Overview" />
          </div>

        </div>
      </section>

      {/* Overview Section */}
      <section className="web-dev-overview-section">
        <div className="web-dev-overview-container">
          {/* Left: Cards Section */}
          <div className="web-dev-cards-container">
            <div className="web-dev-card">
              <FaRobot className="web-dev-card-icon" />
              <h3>Automated Machine Learning</h3>
              <p>
                Leverage AutoML to accelerate model development and deployment while maintaining high accuracy.
              </p>
            </div>
            <div className="web-dev-card">
              <FaCheckCircle className="web-dev-card-icon" />
              <h3>Model Validation</h3>
              <p>
                Rigorous testing and validation to ensure models perform reliably in real-world scenarios.
              </p>
            </div>
            <div className="web-dev-card">
              <FaEye className="web-dev-card-icon" />
              <h3>Explainable AI</h3>
              <p>
                Transparent models that provide insights into decision-making processes for trust and compliance.
              </p>
            </div>
            <div className="web-dev-card">
              <FaSyncAlt className="web-dev-card-icon" />
              <h3>Continuous Learning</h3>
              <p>
                Models that improve over time through continuous training on new data.
              </p>
            </div>
          </div>

          {/* Right: Overview Section */}
          <div className="web-dev-overview-content">
            <h2 className="web-dev-overview-title">
              Unleashing Business Potential with Artificial Intelligence
            </h2>
            <p className="web-dev-overview-description">
              In today's data-driven world, artificial intelligence is no longer optional - it's essential for staying competitive.
              Our AI and machine learning solutions transform raw data into actionable intelligence, automating complex processes,
              uncovering hidden insights, and enabling smarter decision-making. From predictive analytics that forecast market trends
              to computer vision systems that revolutionize quality control, we build custom AI solutions tailored to your specific
              business challenges. Our approach combines cutting-edge algorithms with deep domain expertise to deliver solutions
              that are not just technically sophisticated but also drive measurable business impact. Whether you need to optimize
              operations, personalize customer experiences, or create entirely new AI-powered products, we have the expertise to
              make it happen. This is how we're shaping the future of business - one intelligent algorithm at a time.
            </p>
          </div>
        </div>
      </section>

      {/* Flipping Cards Section */}
      <section className="web-dev-flipping-cards-section">
        <h2 className="flipping-cards-title">
          Ready to Harness the Power of AI for Your Business?
        </h2>
        <p className="flipping-cards-subtitle">
          Connect with our AI experts to explore how machine learning can solve your unique business challenges and create competitive advantages.
        </p>
        <div className="flipping-cards-container">
          {flipCards.map((card, index) => (
            <div className="flipping-card" key={index}>
              <div className="flipping-card-inner">
                <div className="flipping-card-front">
                  <div className="flipping-card-icon">{card.icon}</div>
                  <h3>{card.title}</h3>
                </div>
                <div className="flipping-card-back">
                  <p>{card.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Accountability Section */}
      <section className="accountability-section">
        <div className="accountability-header">
          <div className="accountability-header-left">
            <h1>We take absolute Accountability!</h1>
          </div>
          <div className="accountability-header-right">
            <p>
              Choose us for deep AI expertise, proven experience in delivering production-grade models,
              and commitment to building ethical, responsible AI solutions that deliver real business value.
            </p>
            <Button
              className="custom-gradient-button"
              icon={<ArrowRightOutlined />}
              iconPosition="end"
              onClick={() => navigate('/chaat')}
            >
              Let's Chat
            </Button>
          </div>
        </div>
        <div className="accountability-grid">
          {accountabilityItems.map((item, index) => (
            <div key={index} className="accountability-item">
              <div className="accountability-number">{item.number}</div>
              <div className="accountability-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default AIMLDevelopment;